import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import VideoPage from "./pages/VideoPage";
import TagPage from "./pages/TagPage";
import SearchPage from "./pages/SearchPage";
import TrendingPage from "./pages/TrendingPage";
import FollowingPage from "./pages/FollowingPage";
import ProfilePage from "./pages/ProfilePage";
import LivePage from "./pages/LivePage";
import LiveStreamPage from "./pages/LiveStreamPage";
import SettingsPage from "./pages/SettingsPage";
import NotificationsPage from "./pages/NotificationsPage";
import { NIP19Page } from "./pages/NIP19Page";
import AdminPage from "./pages/AdminPage";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/trending" element={<TrendingPage />} />
        <Route path="/following" element={<FollowingPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/tag/:tag" element={<TagPage />} />
        <Route path="/video/:id" element={<VideoPage />} />
        <Route path="/live" element={<LivePage />} />
        <Route path="/live/:pubkey/:dTag" element={<LiveStreamPage />} />
        {/* Profile page via hex pubkey */}
        <Route path="/profile/:pubkey" element={<ProfilePage />} />
        {/* Settings */}
        <Route path="/settings" element={<SettingsPage />} />
        {/* Notifications */}
        <Route path="/notifications" element={<NotificationsPage />} />
        {/* Admin — hidden, access-gated by pubkey check inside the component */}
        <Route path="/admin" element={<AdminPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
